export const BLOCKED_CLASS_NAME = 'rbac-block';
